import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopProvider = () => {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
};

export default ScrollToTopProvider;
